import React from 'react';
import { useCssHandles } from '../../../utils/functions';
import { useListContext } from '../ListContextProvider';

const CSS_HANDLES = ['list', 'item'] as const;

interface Props {
	listElement?: string;
	itemElement?: string;
	blockClass?: string | Array<string>;
}

const ListContextRenderer = ({ listElement = 'Fragment', itemElement = 'Fragment', blockClass }: Props) => {
	const list = useListContext()?.list ?? [];
	const { handles }: any = useCssHandles(`vtex-list-context-0-x`, CSS_HANDLES, blockClass);

	const ListElement = listElement === 'Fragment' ? React.Fragment : listElement;
	const ItemElement = itemElement === 'Fragment' ? React.Fragment : itemElement;
	const listProps = listElement === 'Fragment' ? {} : { className: handles.list };
	const itemProps = itemElement === 'Fragment' ? {} : { className: handles.item };
	return (
		<ListElement {...listProps}>
			{list.map((item: any, idx: number) => (
				<ItemElement {...itemProps} key={idx}>
					{item}
				</ItemElement>
			))}
		</ListElement>
	);
};

export default ListContextRenderer;
